import { LenderApprovalStatus } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../Text';

export const LenderApprovalStatusOptions = Object.values(LenderApprovalStatus).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
